import { map } from 'lodash';
import { formatAddress } from 'utils';

const fullNameField = 'fullName';
const residenceAddressField = 'residenceAddress';
const titles = {
  inn: 'ИНН',
  [fullNameField]: 'ФИО',
  [residenceAddressField]:
    'Адрес места жительства (места пребывания при отсутствии места жительства)',
  snils: 'СНИЛС',
  email: 'Адрес электронной почты',
};
const fullNameFields = ['lastName', 'firstName', 'middleName'];

export default function getVipnetCertificateFields(personalData) {
  return map(titles, (title, field) => {
    let item = {
      title,
      value: personalData[field] || '—',
    };
    if (field === fullNameField) {
      item.value = fullNameFields.reduce(
        (name, field) => `${name}${personalData[field] || ''} `,
        '',
      );
    }

    if (field === residenceAddressField) {
      item.value = formatAddress(personalData[field] || '') || '—';
    }

    return item;
  });
}
